module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/363.9b120c87.png";